const faqs = [
  {
    q: '被窝网电影是否需要注册或付费？',
    a: '完全不需要。被窝网电影大全是一个免费高清影视资源聚合平台，所有内容均可免费在线观看，无需注册账号，无需支付任何费用。我们致力于让每一位影迷都能零门槛享受观影乐趣。',
  },
  {
    q: '为什么有些影片播放时会缓冲？',
    a: '平台采用智能CDN加速和多线路自动切换技术，绝大多数影片可实现流畅播放。如果偶遇缓冲，建议检查当前网络环境，或尝试切换到备用播放线路。我们也在持续优化服务器节点，提升整体播放体验。',
  },
  {
    q: '网站上的资源多久更新一次？',
    a: '被窝网电影保持每日更新频率，热门电视剧通常在上线后2小时内完成同步。电影资源在院线下映后第一时间收录高清版本。首页推荐内容每日轮换，确保你每次访问都有新鲜内容。',
  },
  {
    q: '支持哪些设备观看？',
    a: '被窝网电影完美适配电脑、平板和手机端。无需下载任何APP或插件，使用浏览器即可直接观看。HTML5播放器兼容主流浏览器（Chrome、Safari、Edge等），横屏竖屏自由切换。',
  },
  {
    q: '如何找到我想看的影片？',
    a: '你可以通过首页的分类索引、热播榜单、话题标签快速发现内容，也可以使用站点搜索功能按片名或类型查找。精选专题和每日推荐也能帮你发现口碑佳作，不会错过任何好片。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            快速了解被窝网电影的使用方式和特色功能
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer" open>
              <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-semibold text-foreground-900 hover:text-primary-600 transition-colors list-none">
                <span className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold flex-shrink-0">
                    {i + 1}
                  </span>
                  {faq.q}
                </span>
                <i className="ri-arrow-up-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
              </summary>
              <div className="px-5 pb-5 pl-14">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}